<script setup lang="ts">
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { useRouter } from 'vue-router'

import { createBatchPackingList } from '@/api/batches'
import GeneratePackingListForm from '@/components/features/batches/forms/GeneratePackingListForm.vue'
import { useGeneratePackingList } from '@/composables/useGeneratePackingList'

const props = defineProps<{
    showGeneratePackingListDialog: boolean
    close: () => void
    batchNumber: string
    batchId: string
    finishingSupplierId: string
    rolls: Array<{ id: string }>
}>()

const router = useRouter()

const { values: packingListValues, handleSubmit: handleGeneratePackingList, setErrors, generatePackingListLoading, showToast } =
  useGeneratePackingList();

  const handledGeneratePackingList = handleGeneratePackingList(async () => {
    generatePackingListLoading.value = true;
  try {
    const formData = {
      ...packingListValues,
      batchId: props.batchId,
      finishingSupplierId: props.finishingSupplierId,
      rollIds: props.rolls.map(roll => roll.id)
    };
    if (formData.packingListDate === undefined) {
    showToast('error', 'Error', 'Please select a date for the packing list.')
    generatePackingListLoading.value = false
    return
  }
    const response = await createBatchPackingList(formData);
    generatePackingListLoading.value = false;
    showToast('success', 'Packing List Generated!', 'You have successfully generated a packing list.');
    router.push(`/packingList/${response.id}`);
  } catch (error) {
    console.error('Error generating packing list:', error);
    generatePackingListLoading.value = false;
    showToast('error', 'An error occurred!', 'Unable to generate a packing list.');
  }
});

</script>

<template>

   <!-- Generate packing list dialog -->
  <Dialog
    :visible="showGeneratePackingListDialog"
    :draggable="false"
    :style="{ width: '70rem' }"
    :closable="false"
  >
    <h3 class="font-bold text-md">Supplier Packing List</h3>
    <GeneratePackingListForm
      :values="packingListValues"
      :onSubmit="handleGeneratePackingList"
      :setErrors="setErrors"
      :batchNumber="batchNumber"
      :finishingSupplierId="finishingSupplierId"
      :rolls="rolls"
    />
    <div class="flex flex-row gap-8 justify-end items-center mt-8">
      <Button
        severity="secondary"
        @click="close"
        label="Cancel"
        class="min-w-48"
      >
        <template #icon>
          <Icon icon="mdi:close" class="text-xl ml-3 order-1" />
        </template>
      </Button>
      <Button @click="handledGeneratePackingList" label="Save Packing List" class="min-w-48">
        <template #icon>
          <Icon icon="material-symbols:save" class="text-xl ml-3 order-1" />
        </template>
      </Button>
    </div>
  </Dialog>
</template>